
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import List from '@/common/components/UI/List/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'

// module components
import RaketaRPKListItem from '@/modules/RPKModule/components/RaketaRPKListItem/index.vue'
import RPKFilters from '@/modules/RPKModule/components/RPKFilters/index.vue'

// types
import { RaketaRPKT, RPKListParamsT } from '@/core/types/rpk.types'

// realisations
import { rpk } from '@/core/realisations/rpk.realisation'

// classes
import { DataState } from '@/core/classes/DataState.class'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'failed-fetch': FailedFetch,
        list: List,
        'raketa-rpk-list-item': RaketaRPKListItem,
        'rpk-filters': RPKFilters,
        'the-button': TheButton,
        NewPagination,
        NewLimit,
    },
    setup() {
        const state = reactive({
            is_loading: false,
        })

        const data_state = reactive({
            raketa_rpk: new DataState<RaketaRPKT>({}),
        })

        const filter_state = reactive({
            id: undefined as number | undefined,
            ftl_order_id: undefined as number | undefined,
            created_at_from: undefined as string | undefined,
            created_at_to: undefined as string | undefined,
            type: undefined as number | undefined,
            company_id: undefined as number | undefined,
            act_number: undefined as string | undefined,
            act_date: undefined as string | undefined,
            status_id: undefined as number | undefined,
            limit: 50,
        })

        const loadRaketaRPKList = async (page: number) => {
            data_state.raketa_rpk.pagination.current_page = page

            // filters
            const params = {
                page,
                ...filter_state,
            }

            try {
                state.is_loading = true
                const response = await rpk.getRaketaRPKList(params)

                data_state.raketa_rpk.list = response.data
                data_state.raketa_rpk.pagination.total_pages = response.meta.last_page
                data_state.raketa_rpk.pagination.total_items = response.meta.total

                data_state.raketa_rpk.is_failed = false
                data_state.raketa_rpk.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.raketa_rpk.failure.catchError(error)

                if (!data_state.raketa_rpk.failure.error_state.is_cancel) {
                    data_state.raketa_rpk.is_failed = true
                }
            } finally {
                if (!data_state.raketa_rpk.failure.error_state.is_cancel) {
                    data_state.raketa_rpk.is_loading = false
                }

                state.is_loading = false
            }
        }

        const onSearch = (rpk: RPKListParamsT) => {
            filter_state.id = rpk.id
            filter_state.ftl_order_id = rpk.ftl_order_id
            filter_state.created_at_from = rpk.created_at_from
            filter_state.created_at_to = rpk.created_at_to
            filter_state.type = rpk.type
            filter_state.company_id = rpk.company_id
            filter_state.act_number = rpk.act_number
            // filter_state.act_date = rpk.act_date
            filter_state.status_id = rpk.status_id

            loadRaketaRPKList(1)
        }

        const onReset = () => {
            filter_state.id = undefined
            filter_state.ftl_order_id = undefined
            filter_state.created_at_from = undefined
            filter_state.created_at_to = undefined
            filter_state.type = undefined
            filter_state.company_id = undefined
            filter_state.act_number = undefined
            filter_state.act_date = undefined
            filter_state.status_id = undefined

            loadRaketaRPKList(1)
        }

        const onLimitChange = (limit: number) => {
            filter_state.limit = limit
            loadRaketaRPKList(data_state.raketa_rpk.pagination.current_page)
        }

        const onChangePage = (page: number) => {
            loadRaketaRPKList(page)
        }

        onBeforeMount(() => {
            loadRaketaRPKList(1)
        })

        return {
            state,
            data_state,
            filter_state,
            // Raketa
            onLimitChange,
            onChangePage,
            loadRaketaRPKList,
            onSearch,
            onReset,
        }
    },
})
